// Local storage keys
export const CUSTOMER_WIDGET_TOKEN_KEY = "redo.widget_auth_token";

// DOM elements
export const CUSTOMER_WIDGET_ELEMENT_ID = "redo-chat-widget";

// Window events
export const OPEN_CUSTOMER_WIDGET_EVENT_KEY = "open_customer_widget";
export const REDO_USER_LOGGED_IN_EVENT_KEY = "redo_user_logged_in";
